module.exports = __webpack_public_path__ + "img/thumbnail.6872b1fc.jpg";